import { KeyInfo } from './types'

/**
 * Checks if the screen size is small.
 * @returns {boolean} True if the screen width is less than or equal to 991 pixels, otherwise false.
 */
export function isScreenSizeSmall(): boolean {
  return window.innerWidth <= 991
}

/**
 * Finds a key by its row key.
 * @param {KeyInfo[]} keys - The array of keys.
 * @param {string} rowKey - The row key to search for.
 * @returns {KeyInfo | undefined} The key with the matching row key, or undefined if not found.
 */
export function getKeyBySlug(keys, rowKey: string): KeyInfo | undefined {
  return keys.find((c: KeyInfo) => c.rowKey === rowKey)
}

/**
 * Validates the keys based on the presence of a continuation token.
 * @param {object} keys - The keys object containing a continuation token.
 * @param {object} getKeysRequest - The request object containing a continuation token.
 * @returns {boolean} True if either of the continuation tokens is present and not empty, otherwise false.
 */
export const validateKey = (keys, getKeysRequest): boolean => {
  if (
    (keys.continuationToken !== null &&
      keys.continuationToken !== undefined &&
      Object.keys(keys.continuationToken).length !== 0) ||
    (getKeysRequest.continuationToken !== null &&
      getKeysRequest.continuationToken !== undefined &&
      getKeysRequest.continuationToken.length !== 0)
  ) {
    return true
  }
  return false
}
